var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatVendor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#666666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM4 4H20V16H5.17L4 17.17V4ZM15 8H15.8C16.4 8 17 8.6 17 9.3V13.8C17 14.4 16.4 15 15.7 15H8.2C7.6 15 7 14.4 7 13.7V9.2C7 8.6 7.6 8 8.2 8H9C9 6 10.6 5 12 5C13.4 5 15 6 15 8ZM10.5 7.99922C10.5 7.19922 11.2 6.5 12 6.5C12.8 6.5 13.5 7.19922 13.5 7.99922H10.5ZM8.5002 13.4992H15.5002V11.5009V9.49984C15.2857 9.49984 14.7187 9.49976 13.9941 9.49965C12.0169 9.49936 8.86611 9.4989 8.5002 9.49949V13.4992Z",
    fill: "inherit",
    fillOpacity: 0.87
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatVendor);
export default __webpack_public_path__ + "static/media/chat_vendor.1585bc99e60dd7919671ee9fccd321f3.svg";
export { ForwardRef as ReactComponent };